export type PlaybackPolicyStream = {
  id: string;
  type?: string;
  url: string;
  active: boolean;
  mode?: string | null;
  lowLatency?: boolean;
  cacheMs?: number;
  targets?: Array<{
    engines?: Array<{
      config?: Record<string, unknown> | null;
    }> | null;
  }> | null;
};

export const DEFAULT_PLAYBACK_RECEIVER_BUFFER_MS = 400;

export const resolvePlaybackReceiverBufferMs = (
  playback: PlaybackPolicyStream | null,
): number => {
  if (!playback) return 0;
  if (playback.mode?.trim().toLowerCase() === "recast") return 0;
  if (playback.lowLatency) return 0;
  const configured = playback.cacheMs;
  if (typeof configured !== "number" || !Number.isFinite(configured)) {
    return DEFAULT_PLAYBACK_RECEIVER_BUFFER_MS;
  }
  return Math.min(10_000, Math.max(1, Math.round(configured)));
};
